import React, { useState } from 'react';

function BlurredImage({ src, alt, ...props }) {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <img
      src={src}
      alt={alt}
      onLoad={() => setIsLoaded(true)}
      className={`w-full h-auto transition-all duration-500 ease-in-out ${
        isLoaded ? 'blur-0 opacity-100' : 'blur-md opacity-30'
      }`}
      {...props}
    />
  );
}

export default BlurredImage;
